import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import * as ExcessUtil from 'notebook/tables/excess/Util';
import filterNumbers from 'notebook/tables/excess/util/filterNumbers';

export default {
  name: 'COUNT',
  shortDescription: 'The number of numeric values in a dataset.',
  category: FunctionCategory.STATS,
  description: 'Returns a count of the number of numeric values in a dataset.',
  params: [
    {
      name: 'value',
      type: ArgType.any,
      description: 'The first value or range to consider when counting.',
    },
  ],
  repeatableLastParamType: ArgType.any,
  repeatableLastParamDescription: 'Additional values or ranges to consider when counting.',
  returnType: ExcessUtil.VALUE_TYPES.NUMBER,

  eval: (...values): number => {
    const numberValues = filterNumbers(values);
    return numberValues.length;
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
